/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable radix */
import { useContext } from '@wordpress/element';
import Context from '../context/context';

const Population = props => {
    const { handleRangeChange } = props;
    const context = useContext(Context);
    const { data, updateGroupData } = context;

    const clickCountry = group => {
        updateGroupData(group);
        handleRangeChange(1);
    };

    console.log({ context });

    return (
        <>
            <div className="table ranks">
                <p className="all">All U.S. Asians -- 20,416,808</p>
                <div className="selection">
                    <div data-filter="total" className="active">
                        Total
                    </div>
                </div>
                <div className="rows">
                    {data &&
                        data
                            .sort((a, b) => (a.order > b.order ? 1 : -1))
                            .map(d => {
                                return (
                                    'All Asians' !== d.group && (
                                        <div
                                            className="row"
                                            onClick={() =>
                                                clickCountry(d.group)
                                            }
                                        >
                                            <div className="name">
                                                {' '}
                                                {d.group}{' '}
                                            </div>
                                            <div className="pop">
                                                {parseInt(
                                                    d.population,
                                                ).toLocaleString()}
                                            </div>
                                        </div>
                                    )
                                );
                            })}
                </div>
            </div>
        </>
    );
};

export default Population;
